<template>
  <div class="tw-text-xxs tw-truncate">
    {{ parsedTags }}
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      required: true,
      default: ['lorem', 'ipsum dolor sit amet', 'consectetur', 'adipisicing elit. Ad aperiam']
    }
  },
  computed: {
    parsedTags() {
      if (this.tags && this.tags.length > 0) {
        return `#${this.tags.map(tag => tag.name).join("   #")}`;
      } else {
        return ''
      }
    }
  }
}
</script>
